module.exports = __webpack_public_path__ + "static/media/Marotte_Frene_Excelsior_MT4-09-Panel.12e1d926.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Frene_Excelsior_MT4-09-Panel.jpg
// module id = 955
// module chunks = 37